export default __webpack_public_path__ + "static/media/rambouillet08.0a898c6c.jpg";